<template>
  <div class="rekap-angka">
    <div class="baris">
      <div class="kotak">
        <div>Total RTLH</div>
        <div>{{ rekap.TotalRTLH | format }}</div>
      </div>
      <div class="kotak">
        <div>Layak Huni</div>
        <div>{{ rekap.TotalRTLHLayakHuni | format }}</div>
      </div>
      <div class="kotak">
        <div>Validasi</div>
        <div>{{ rekap.TotalRTLHValidasi | format }}</div>
      </div>
      <div class="kotak">
        <div>Sisa</div>
        <div>{{ rekap.TotalRTLHSisa | format }}</div>
        <div class="sub-kotak">
          <div>BDT</div>
          <div>
            {{ rekap.TotalRTLHSisaBDT | format }}
          </div>
          <div>Lengkap</div>
          <div>{{ rekap.TotalRTLHSisaBDT1 | format }}</div>
          <div>Blm Lengkap</div>
          <div>{{ rekap.TotalRTLHSisaBDT0 | format }}</div>
        </div>
        <div class="sub-kotak">
          <div>Non-BDT</div>
          <div>
            {{ rekap.TotalRTLHSisaNonBDT | format }}
          </div>
          <div>Lengkap</div>
          <div>{{ rekap.TotalRTLHSisaNonBDT1 | format }}</div>
          <div>Blm Lengkap</div>
          <div>{{ rekap.TotalRTLHSisaNonBDT0 | format }}</div>
        </div>
      </div>
      <div class="kotak">
        <div>BDT</div>
        <div>{{ rekap.TotalRTLHBDT | format }}</div>
        <div>Syarat Lengkap</div>
        <div>{{ rekap.TotalRTLHBDT1 | format }}</div>
        <div>Belum Lengkap</div>
        <div>{{ rekap.TotalRTLHBDT0 | format }}</div>
      </div>
      <div class="kotak">
        <div>Non-BDT</div>
        <div>{{ rekap.TotalRTLHNonBDT | format }}</div>
        <div>Syarat Lengkap</div>
        <div>{{ rekap.TotalRTLHNonBDT1 | format }}</div>
        <div>Belum Lengkap</div>
        <div>{{ rekap.TotalRTLHNonBDT0 | format }}</div>
      </div>
    </div>
    <div class="baris">
      <div class="kotak">
        <div>Total Backlog</div>
        <div>{{ rekap.TotalBacklog | format }}</div>
      </div>
      <div class="kotak">
        <div>Memiliki Rumah</div>
        <div>{{ rekap.TotalBacklogLayak | format }}</div>
      </div>
      <div class="kotak">
        <div>Validasi</div>
        <div>{{ rekap.TotalBacklogValidasi | format }}</div>
      </div>
      <div class="kotak">
        <div>Sisa</div>
        <div>{{ rekap.TotalBacklogSisa | format }}</div>
        <div class="sub-kotak">
          <div>BDT</div>
          <div>
            {{ rekap.TotalBacklogSisaBDT | format }}
          </div>
          <div>Lengkap</div>
          <div>{{ rekap.TotalBacklogSisaBDT1 | format }}</div>
          <div>Blm Lengkap</div>
          <div>{{ rekap.TotalBacklogSisaBDT0 | format }}</div>
        </div>
        <div class="sub-kotak">
          <div>Non-BDT</div>
          <div>
            {{ rekap.TotalBacklogSisaNonBDT | format }}
          </div>
          <div>Lengkap</div>
          <div>{{ rekap.TotalBacklogSisaNonBDT1 | format }}</div>
          <div>Blm Lengkap</div>
          <div>{{ rekap.TotalBacklogSisaNonBDT0 | format }}</div>
        </div>
      </div>
      <div class="kotak">
        <div>BDT</div>
        <div>
          {{ (rekap.TotalBacklogBDT1 + rekap.TotalBacklogBDT0) | format }}
        </div>
        <div>Syarat Lengkap</div>
        <div>{{ rekap.TotalBacklogBDT1 | format }}</div>
        <div>Belum Lengkap</div>
        <div>{{ rekap.TotalBacklogBDT0 | format }}</div>
      </div>
      <div class="kotak">
        <div>Non-BDT</div>
        <div>
          {{ (rekap.TotalBacklogNonBDT0 + rekap.TotalBacklogNonBDT1) | format }}
        </div>
        <div>Syarat Lengkap</div>
        <div>{{ rekap.TotalBacklogNonBDT1 | format }}</div>
        <div>Belum Lengkap</div>
        <div>{{ rekap.TotalBacklogNonBDT0 | format }}</div>
      </div>
    </div>
    <div class="baris">
      <div class="kotak" style="width:calc(30vw - 100px)">
        <div>Data Kemiskinan</div>
        <div>{{ rekap.TotalMiskin | format }}</div>
      </div>
      <div class="kotak" style="width:calc(30vw - 100px)">
        <div>Intervensi</div>
        <div>{{ rekap.TotalMiskinLayak | format }}</div>
      </div>
      <div class="kotak" style="width:calc(30vw - 100px)">
        <div>Validasi</div>
        <div>{{ rekap.TotalMiskinValidasi | format }}</div>
      </div>
      <div class="kotak" style="width:calc(30vw - 100px)">
        <div>Sisa</div>
        <div>{{ rekap.TotalMiskinSisa | format }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    rekap: {},
  }),
  async mounted() {
    let res = await this.$api.call('PRM_RptRekapAngka')
    this.rekap = res.data[0]
  },
}
</script>
<style lang="scss">
.rekap-angka {
  .baris {
    display: flex;
    padding: 15px;
    background: rgba(255, 255, 255, 0.5);
    margin-bottom: 10px;
    justify-content: space-between;

    .kotak {
      background: rgba(255, 255, 255, 0.7);
      border-radius: 5px;
      padding: 15px;
      width: calc(17% - 20px);
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);

      & > div:nth-child(odd) {
        font-size: 14px;
        font-weight: bold;
      }

      & .sub-kotak {
        display: inline-block;
        vertical-align: top;
        font-size: small !important;
        font-weight: normal !important;
        margin-right: 10px;
        & > div:nth-child(odd) {
          font-size: small;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
